import { render, staticRenderFns } from "./SettingsIndexesWebPage.vue?vue&type=template&id=73420662&"
import script from "./SettingsIndexesWebPage.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesWebPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports